import React from 'react'
import ReactDOM from 'react-dom'

import FontPreviewComponent from './_font_preview_component'

class FontPreview {
  constructor (props) {
    this.rootElement = props.rootElement
    this.props = props
  }

  render () {
    ReactDOM.render(
      <FontPreviewComponent
        fontFilenames={this.props.fontFilenames}
        endpoint={this.props.serviceEndpoint}
        itemId={this.props.itemId}
        itemName={this.props.itemName}
        version={this.props.version}
      />,
      document.querySelector(this.rootElement)
    )
  }
}

export default FontPreview
